import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-phone-qualification.component.ajs.html';

const MODULE_NAME = 'agentBookingPhoneQualification';

class AgentBookingPhoneQualificationCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingPhoneQualification implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingPhoneQualificationCtrl];
}

export default MODULE_NAME;
